import { userHooks } from '../trpcHooks/user'

export function usePermissions() {
  const { data: user } = userHooks.useMe()

  const isOwnerOf = (customerId: number): boolean => {
    return (
      user?.customerMemberships?.find((m) => m.customerId === customerId)
        ?.accessRole === 'owner'
    )
  }

  const getCustomerRole = (
    customerId: number,
  ): 'owner' | 'member' | null | undefined => {
    return user?.customerMemberships?.find((m) => m.customerId === customerId)
      ?.accessRole
  }

  return {
    isOwnerOf,
    getCustomerRole,
    user,
  }
}
